
import { Component, Vue, Prop } from 'vue-property-decorator';
import searchIcon from '../assets/icon/icon-search.svg';
import resetIcon from '../assets/icon/icon-close.svg'
import IconFilter from '../assets/icon/icon-filter.svg'
import BaseNavLink from './ui/BaseNavLink.vue';
import BaseInput from './ui/BaseInput.vue';
import BaseButton from './ui/BaseButton.vue';
import BaseLogo from './ui/BaseLogo.vue';
import BaseDivider from './ui/BaseDivider.vue';
import FilterProduct from './FilterProduct.vue';

@Component({
    components: {
        BaseNavLink, BaseInput, BaseButton, BaseLogo, BaseDivider, IconFilter, FilterProduct
    }
})
export default class Header extends Vue {
    @Prop({ required: true }) readonly categories!: any[];
    @Prop({ required: true }) readonly brands!: string[];
    @Prop({ required: true }) readonly sizes!: string[];

    private searchIcon: string = searchIcon;
    private resetIcon: string = resetIcon;
    private isFilterVisible: boolean = false;

    toggleFilter() {
        this.isFilterVisible = !this.isFilterVisible;
    }
}
